import React, {Component} from 'react';
import {connect} from 'react-redux';
import SiteHeader from '@homeaway/react-site-header';
import BirdhouseComponent from '../BirdhouseComponent/BirdhouseComponent';
import TransitionBannerContainer, {
    BannerProps,
} from '../TransitionBannerContainer/TransitionBannerContainer';
import {BirdhouseProps} from '../BirdhouseComponent/BirdhouseComponent';
import './BirdhouseContainer.less';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return {
        site: state.site,
        serviceUrl: state.serviceUrl,
        experiments: state.experiments,
        ticket: state.ticket,
        landingPage: state.landingPage,
        isLegacy: state.isLegacy,
        isOwner: state.isOwner,
        isCreatePassword: state.isCreatePassword,
        actionLocation: state.actionLocation,
        edapEventLoginSource: state.edapEventLoginSource,
        bannerData: state.bannerData,
        skipCas: state.skipCas,
        insecureFlow: state.insecureFlow,
        siteCheckEnabled: state.siteCheckEnabled,
        preferenceType: state.marketingOptInType.sign_up,
    };
}

class BirdhouseContainer extends Component<BirdhouseProps & BannerProps> {
    componentDidMount() {
        window.ha.userTiming.mark('primary.action.rendered');
        document.body.classList.add(
            `body-bg-color--${this.props.site.siteName}`
        );
    }

    render() {
        const siteHeaderProps = {
            dataUrl: '/traveler/api/header',
            siteName: this.props.site.siteName,
        };

        return (
            <div className="center-block text-center BirdhouseContainer">
                <SiteHeader
                    {...siteHeaderProps}
                    withoutTray
                    withoutNav
                    withoutListYourProperty
                />
                {this.props.isOwner &&
                    Object.keys(this.props.bannerData).length !== 0 && (
                        <div className="text-left">
                            <TransitionBannerContainer
                                bannerData={this.props.bannerData}
                                experiments={this.props.experiments}
                            />
                        </div>
                    )}
                <BirdhouseComponent
                    site={this.props.site}
                    serviceUrl={this.props.serviceUrl}
                    ticket={this.props.ticket}
                    landingPage={this.props.landingPage}
                    isLegacy={this.props.isLegacy}
                    isOwner={this.props.isOwner}
                    isCreatePassword={this.props.isCreatePassword}
                    actionLocation={this.props.actionLocation}
                    edapEventLoginSource={this.props.edapEventLoginSource}
                    skipCas={this.props.skipCas}
                    insecureFlow={this.props.insecureFlow}
                    siteCheckEnabled={this.props.siteCheckEnabled}
                    preferenceType={this.props.preferenceType}
                />
            </div>
        );
    }
}

export default connect(mapStateToProps)(BirdhouseContainer);
